import '../styles/LoginForm.css';
import { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaUser, FaLock } from 'react-icons/fa';

export default function LoginForm() {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const { login } = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    document.body.classList.add('login-page-body');
    return () => {
      document.body.classList.remove('login-page-body');
    };
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/auth/login', {
        username: user,
        password: pass
      });
      login(res.data.token);
      localStorage.setItem('token', res.data.token);
      history.push('/dashboard');
    } catch (err) {
      toast.error("Credenciales incorrectas");
    }
  };

  return (
    <>
    <ToastContainer/>
    <div className="login-container">
      <h2>Acceso a OrtoImplantApp</h2>
      <form onSubmit={handleSubmit}>
        <div className="input-wrapper">
          <FaUser className="input-icon" />
          <input
            type="text"
            value={user}
            onChange={e => setUser(e.target.value)}
            placeholder="Usuario"
            required
          />
        </div>
        <div className="input-wrapper">
          <FaLock className="input-icon" />
          <input
            type="password"
            value={pass}
            onChange={e => setPass(e.target.value)}
            placeholder="Contraseña"
            required
          />
        </div>
        <button type="submit">Entrar</button>
      </form>
    </div>
    </>
  );
}
